module.exports = __webpack_public_path__ + "static/media/feather-settings.65e24ccd.svg";